<div id="notfound-wrapper">
  <div class="notfound animated fadeIn slow">
    <div class="notfound-404"><h1>404</h1></div>
    <h2>Página no encontrada</h2>
    <p>
      La página que está buscando podría haberse eliminado, ha cambiado su
      nombre o no está disponible temporalmente.
    </p>
    <a mat-raised-button color="primary" href="#">
      Ir la página de inicio
    </a>
  </div>
</div>
